import React from 'react'
import { Checkbox, Select } from 'antd'
import { PermissionTreeNode } from '../utils'

interface PermissionTreeItemProps {
  node: PermissionTreeNode
  level: number
  currentValue: boolean | string | null
  onCheckboxChange: (e: any) => void
  onSelectChange: (value: string | null, id: number) => void
  isVisible: boolean
  children?: React.ReactNode
}

/** Права со scope «назначенные пользователю» (бэкенд фильтрует по responsible). */
const RESPONSIBLE_SCOPE_PERMISSIONS = ['access_measurement', 'access_montage']

/**
 * Фолбэк для тенантов, у которых в permissions_new ещё нет опции `responsible`
 * (она досоздаётся при подключении модуля / bootstrap).
 */
function withResponsibleScope<T extends { label: string; value: any }>(
  name: string | undefined,
  options: T[] | undefined,
): T[] | undefined {
  if (!options || !name || !RESPONSIBLE_SCOPE_PERMISSIONS.includes(name)) return options
  if (options.some(o => o.value === 'responsible')) return options
  const next = [...options]
  const disabledIndex = next.findIndex(o => o.value == null)
  next.splice(disabledIndex >= 0 ? disabledIndex + 1 : 0, 0, {
    label: 'Только, назначенные пользователю',
    value: 'responsible',
  } as T)
  return next
}

export const PermissionTreeItem: React.FC<PermissionTreeItemProps> = ({
  node,
  level,
  currentValue,
  onCheckboxChange,
  onSelectChange,
  isVisible,
  children,
}) => {
  if (!isVisible) {
    return null
  }

  const isCheckbox = node.settings.type === 'checkbox'
  const isSelect = node.settings.type === 'select'
  const selectOptions = withResponsibleScope(node.name, node.settings.options)

  return (
    <div>
      <div
        style={{
          marginBottom: 8,
          marginLeft: level * 8,
        }}
      >
        {isCheckbox && (
          <Checkbox checked={!!currentValue} onChange={onCheckboxChange} value={node.id}>
            <span>{node.description}</span>
          </Checkbox>
        )}

        {isSelect && node.settings.options && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
            <span style={{ minWidth: '250px', fontWeight: 500 }}>{node.description}</span>
            <Select
              style={{ minWidth: '300px' }}
              value={currentValue as string}
              onChange={value => onSelectChange(value, node.id)}
              options={selectOptions}
              allowClear
              placeholder="Выберите уровень доступа"
            />
          </div>
        )}
      </div>

      {children && (
        <div
          style={{
            marginLeft: 8,
          }}
        >
          {children}
        </div>
      )}
    </div>
  )
}
